/**
 * @prettier
 */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { AlertIcon, CheckmarkCircleIcon, Link } from '@zola/zola-ui';
import { trackRecommendation } from '../../../../util/trackingHelper';

import css from './ZoomPlanStatusModule.module.less';

// TODO: add component tests

const elements = {
  PREMIUM: {
    IconComponent: CheckmarkCircleIcon,
    HED: `Looks Like You Have a Paid Zoom Plan`,
    DEK: `Paid plans support events up to 24 hours long with 100 guests (or more if you’ve purchased an upgrade). Check your plan to make sure you can accommodate all guests.`,
  },
  BASIC: {
    IconComponent: AlertIcon,
    HED: `Looks Like You Have Zoom's Basic Plan`,
    DEK: `You can host meetings up to 40 minutes long with 100 guests max. Planning a longer event or inviting more guests? We recommend upgrading your plan.`,
    link: 'Upgrade Your Zoom Plan',
  },
};

const isValidPlanStatus = planStatus => planStatus === 'BASIC' || planStatus === 'PREMIUM';

const ZoomPlanStatusModule = ({ planStatus, fetchZoomPlan, containerStyling }) => {
  useEffect(() => {
    if (!planStatus) {
      fetchZoomPlan();
    }
  }, [planStatus, fetchZoomPlan]);
  if (!isValidPlanStatus(planStatus)) return null;
  const { IconComponent, HED, DEK, link } = elements[planStatus];

  const handleClick = () => {
    trackRecommendation('Clicked', {
      recommendation_key: 'virtual_upgrade_zoom',
      recommendation_name: 'virtual_upgrade_zoom',
      recommendation_copy: 'Upgrade Your Zoom Plan',
    });
  };

  return (
    <div
      className={cx(css.container, {
        [css[`container--${planStatus}`]]: containerStyling,
        [css.containerStyling]: containerStyling,
      })}
    >
      <IconComponent className={css[`icon--${planStatus}`]} height={20} width={20} />
      <div className={css.copy}>
        <span className={css.HED}>{HED}</span>
        <span className={css.DEK}>{DEK}</span>
        {link && (
          <Link
            href="https://zoom.us/pricing"
            arrow
            arrowPosition="postfix"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClick}
          >
            {link}
          </Link>
        )}
      </div>
    </div>
  );
};

ZoomPlanStatusModule.propTypes = {
  planStatus: PropTypes.oneOf(['BASIC', 'PREMIUM']),
  fetchZoomPlan: PropTypes.func,
};

export default ZoomPlanStatusModule;



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ZoomPlanStatusModule/ZoomPlanStatusModule.jsx